export function getMVPUrl (window) {
  const host = window.location.hostname
  let domain = host.split('.').slice(-2).join('.')

  if (domain === 'localhost') {
    domain = 'mapmyrun.com'
  }

  return `http://mvp.${domain}`
}



// WEBPACK FOOTER //
// ./src/shared/urls.js